import {createLazyComponent} from 'helpers/createLazyComponent'
import React from 'react'

const CourseClassExamPageLazy = createLazyComponent(() => import('./CourseClassExamPage'))

const CourseClassExamPage = (props) => <CourseClassExamPageLazy {...props} />

export default CourseClassExamPage
